"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBServicingPositive = function SvgBServicingPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M136.906 143.357a2.44 2.44 0 01-2.44-2.44V25.285A20.404 20.404 0 00114.06 4.881H36.862a2.44 2.44 0 010-4.881h77.199c13.963.004 25.28 11.323 25.285 25.285v115.632a2.44 2.44 0 01-2.44 2.44zM2.44 47.243A2.44 2.44 0 010 44.803V15.897A15.889 15.889 0 0115.897 0a2.44 2.44 0 010 4.881A11 11 0 004.88 15.897v28.906a2.44 2.44 0 01-2.44 2.44z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M20.485 47.186a2.44 2.44 0 01-1.724-.715l-7.322-7.323-7.322 7.274a2.44 2.44 0 01-3.401-3.393l9.047-8.998a2.44 2.44 0 013.45 0l7.321 7.322 6.126-6.093a2.44 2.44 0 113.442 3.433l-7.86 7.818a2.44 2.44 0 01-1.757.675z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M125.402 143.284H29.329a2.44 2.44 0 01-2.44-2.44V15.896A11 11 0 0015.896 4.88a2.44 2.44 0 110-4.881c8.772.009 15.877 7.125 15.872 15.897v122.506h93.633a2.44 2.44 0 010 4.881z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M87.05 31.77H48.61a2.44 2.44 0 110-4.882h38.44a2.44 2.44 0 010 4.881zM117.795 47.186H48.643a2.44 2.44 0 110-4.88h69.152a2.44 2.44 0 010 4.88zM117.795 62.53H48.643a2.44 2.44 0 110-4.881h69.152a2.44 2.44 0 010 4.881zM117.795 77.93H48.643a2.44 2.44 0 110-4.88h69.152a2.44 2.44 0 010 4.88z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M44.656 127.883a2.44 2.44 0 01-2.44-2.44v-19.184a2.44 2.44 0 014.88 0v19.184a2.44 2.44 0 01-2.44 2.44zM79.355 127.883a2.44 2.44 0 01-2.441-2.44v-19.184a2.44 2.44 0 014.881 0v19.184a2.44 2.44 0 01-2.44 2.44zM90.875 127.883a2.44 2.44 0 01-2.441-2.44v-19.184a2.44 2.44 0 014.881 0v19.184a2.44 2.44 0 01-2.44 2.44zM121.635 127.883a2.44 2.44 0 01-2.44-2.44v-19.184a2.44 2.44 0 014.88 0v19.184a2.44 2.44 0 01-2.44 2.44zM67.786 127.883H60.13a2.44 2.44 0 01-2.44-2.44v-19.184a2.44 2.44 0 012.44-2.44h7.656a2.44 2.44 0 012.44 2.44v19.184a2.44 2.44 0 01-2.44 2.44zm-5.215-4.881h2.774V108.7h-2.774v14.302z",
    fill: "#285"
  }), (0, _core.jsx)("rect", {
    fill: "#285",
    x: 103.802,
    y: 103.818,
    width: 8.746,
    height: 24.065,
    rx: 3
  })));
};

var _default = SvgBServicingPositive;
exports["default"] = _default;